import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem
} from '@mui/material';
import { Formik, Form, Field, FormikHelpers } from 'formik';
import * as yup from 'yup';

interface StatusUpdateModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: StatusFormValues, formikHelpers: FormikHelpers<StatusFormValues>) => void;
  initialStatus?: string;
  initialRemarks?: string;
  statusOptions: any[];
}

interface StatusFormValues {
  status: string;
  remarks: string;
}

const validationSchema = yup.object().shape({
  status: yup.string().required('Status is required'),
  remarks: yup.string().max(500, 'Remarks must be under 500 characters'),
});

const StatusUpdateModal: React.FC<StatusUpdateModalProps> = ({
  open,
  onClose,
  onSubmit,
  initialStatus = '',
  initialRemarks = '',
  statusOptions,
}) => {
  const initialValues: StatusFormValues = {
    status: initialStatus,
    remarks: initialRemarks
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Update Status</DialogTitle>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
          <Form className='form-group'>
            <DialogContent dividers>
              <TextField
                select
                fullWidth
                name="status"
                label="Select Status"
                value={values.status}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.status && Boolean(errors.status)}
                helperText={touched.status && errors.status}
                margin="normal"
              >
                {statusOptions.map((status, index) => (
                  <MenuItem key={index} value={status.value}>
                    {status.label}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                fullWidth
                multiline
                rows={3}
                name="remarks"
                label="Remarks"
                value={values.remarks}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.remarks && Boolean(errors.remarks)}
                helperText={touched.remarks && errors.remarks}
                margin="normal"
              />
            </DialogContent>

            <DialogActions>
              <Button onClick={onClose} color="secondary" disabled={isSubmitting}>
                Cancel
              </Button>
              <Button type="submit" variant="contained" disabled={isSubmitting}>
                Update
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default StatusUpdateModal;
